import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { useBrand } from '../brand/BrandProvider';
import { useMe } from '../me/MeProvider';
import { matchPermissions } from './useHasPermission';

function CenteredSpinner() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 gap-3">
      <div className="loader-wrapper">
        <div className="loader" />
      </div>
      <p className="text-muted small mb-0">Operator-Profil wird geladen…</p>
    </div>
  );
}

/**
 * Route-Subtree-Gate. AND auf `perms`, OR auf `anyOf`.
 * Auth-Status-Machine + Brand-Vorbedingung zentralisiert.
 */
export function ProtectedRoute({ perms, anyOf, requiresBrand }) {
  const auth = useAuth();
  const brand = useBrand();
  const me = useMe();
  const location = useLocation();

  if (auth.status === 'loading') return <CenteredSpinner />;
  if (auth.status === 'mfa-pending') return <Navigate to="/mfa-challenge" replace />;
  if (auth.status === 'anonymous') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (brand.status === 'loading' || brand.status === 'idle') return <CenteredSpinner />;
  if (brand.status === 'no-brands') return <Navigate to="/no-access" replace />;

  if (requiresBrand && !brand.currentBrandOrigin) {
    return <Navigate to="/" replace />;
  }

  if (perms?.length || anyOf?.length) {
    if (me.status !== 'ready') return <CenteredSpinner />;
    if (!matchPermissions(me.permissions, { perms, anyOf })) {
      return <Navigate to="/403" replace />;
    }
  }

  return <Outlet />;
}
